import { Component, OnInit } from "@angular/core";
import { GlobalAlertService } from "src/app/services/global-alert.service";
import { GlobalService } from "src/app/services/global.service";
import { Router } from "@angular/router";
import * as $ from "jquery";
import { NgxSpinnerService } from "ngx-spinner";
import * as moment from "moment";
import { Swiper, Navigation, Pagination } from "swiper";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ExcelService } from "src/app/services/excel.service";
import { SubirArchivosService } from "src/app/services/subir-archivos.service";
Swiper.use([Navigation, Pagination]);

@Component({
  selector: "app-ver-ticket",
  templateUrl: "./ver-ticket.component.html",
  styleUrls: ["./ver-ticket.component.scss"],
})
export class VerTicketComponent implements OnInit {

  // ─── Campos del formulario ─────────────────────────────────────────────────
  valorCanal: string;
  valorMenu1: string;
  valorSubMenu1: string = "-";
  valorSubMenu2: string = "-";
  valorSubMenu3: string = "-";
  codigo: any;
  File: any;
  descriptionBenefit: string;
  banderaCrearTicket: boolean = false;
  mensajeAdvertenciaSubMenu3: string = "";
  editandoSubMenu3: boolean = false;
  fechaSeleccionada: string = moment().format("YYYY-MM-DDTHH:mm");
  fechaTipificacion: string = moment().format("YYYY-MM-DDTHH:mm");

  // ─── Datos generales ───────────────────────────────────────────────────────
  IDUSUARIO: string = "";
  clientClass: any;
  informacionBeneficiario: any;
  Historial: any;
  HistorialModal: any[] = [];
  banderaActualizar: boolean = false;
  Archivos: any;
  Estados: any[] = [];
  description: string;
  descriptionModal: string;
  Toexcel: any[] = [];
  estado: any;
  srcImg: any[] = [];
  file: any;
  imgsUrls: any[] = [];
  ticketArchived: boolean = false;
  ticketActive: boolean = false;
  TipificaActive: boolean = false;
  windowB: boolean = true;
  windowA: boolean = false;
  windowC: boolean = true;
  windowD: boolean = true;
  NickName: any;
  NameP: any;
  Evidence: boolean = false;
  flagS: boolean = false;
  Mantenimiento: any[] = [];
  listActived: boolean = true;
  listForschedule: boolean = false;
  ticketsBeneficiario: any;
  banderaTickets: boolean = false;
  Questions: any[] = [];
  comentarios: any[] = [];
  DataTipifica: any;
  DataTipifica2: any;
  banderaMantenice: boolean = false;
  edit: boolean = false;
  creadopor: string;
  banderaComentaruioTecnico: boolean = false;
  comentariaTecnico: any;
  comentario: any;
  IdTicket: string = "";

  // ─── Opciones de menú principal ────────────────────────────────────────────
  readonly canales = [
    { type: "WhatsApp" },
    { type: "Correo" },
    { type: "Linea de Atencion" },
    { type: "Oficina" },
    { type: "Pagina Web" },
  ];

  readonly types = [
    { type: "PETICION" },
    { type: "QUEJA" },
    { type: "RECLAMO" },
    { type: "OTROS" },
  ];

  // ─── Submenús nivel 1 ──────────────────────────────────────────────────────
  readonly typesSubMenu1Peticion = [
    { type: "CONSULTA DE INFORMACION" },
    { type: "SOLICITUD DE FACTURA Y/O COMPROBANTE" },
    { type: "CAMBIO DE TITULARIDAD" },
    { type: "SOLICITUD DE TRASLADO" },
    { type: "AUSENCIA DE EQUIPOS" },
    { type: "SOLICITUD DE DESESTIMIENTO" },
  ];

  readonly typesSubMenu1Queja = [
    { type: "ATENCION DEFICIENTE" },
    { type: "INCONFORMIDAD CON FACTURACION" },
  ];

  readonly typesSubMenu1Reclamo = [
    { type: "DAÑO" },
  ];

  readonly typesSubMenu1Otros = [
    { type: "GESTION DE CARTERA" },
    { type: "LLAMADA DE INFORMACION" },
    { type: "GESTION SOCIAL" },
    { type: "RESULTADO OPERATIVO" },
  ];

  // ─── Submenús nivel 2 ──────────────────────────────────────────────────────

  // Peticion
  readonly typesSubMenu2ConsultaInformacion = [
    { type: "INFORMACION DEL CONTRATO" },
    { type: "ACUERDOS INICIALES" },
  ];

  readonly typesSubMenu2SolicitudFactura = [
    { type: "COPIA DE FACTURA" },
    { type: "COPIA DE COMPROBANTE DE PAGO" },
    { type: "SOLICITUD ESTADO DE CARTERA" },
  ];

  // Queja
  readonly typesSubMenu2AtencionDeficiente = [
    { type: "QUEJAS ADMINISTRATIVAS" },
    { type: "INTERRUPCIONES EN LA PRESTACION DEL SERVICIO" },
    { type: "NO ATENCION DE CONDICIONES DE SEGURIDAD O RIESGO" },
    { type: "TERMINACION DEL CONTRATO" },
    { type: "SUSPENSION O CORTE DEL SERVICIO SIN PREVIO AVISO O SIN CAUSA APARENTE" },
    { type: "AFECTACION AMBIENTAL" },
    { type: "ESTADO DE LA INFRAESTRUCTURA" },
    { type: "FALLAS EN LA CONEXION DEL SERVICIO" },
    { type: "NO CONEXION DEL SERVICIO" },
  ];

  readonly typesSubMenu2InconformidadFacturacion = [
    { type: "COBROS INOPORTUNOS" },
    { type: "COBRO POR SERVICIOS NO PRESTADOS" },
    { type: "DATOS GENERALES INCORRECTOS" },
    { type: "COBRO MULTIPLE Y/O ACUMULADO" },
    { type: "ENTREGA INOPORTUNA O NO ENTREGA DE LA FACTURA" },
    { type: "COBRO POR CONEXION, RECONEXION, REINSTALACION" },
    { type: "COBRO DE CARGOS RELACIONADOS A CARTERA Y/O ACUERDOS DE PAGO" },
    { type: "SUBSIDIOS Y CONTRIBUCIONES" },
    { type: "DESCUENTO POR PREDIO DESOCUPADO" },
    { type: "INCUMPLIMIENTO O NEGACION DEL ACUERDO DE SUSPENSION DEL SERVICIO" },
    { type: "ESTRATO INCORRECTO" },
    { type: "CLASE DE USO INCORRECTO (COMERCIAL, INDUSTRIAL, OFICIAL, OTROS)" },
    { type: "TARIFA INCORRECTA" },
    { type: "COBROS POR PROMEDIO" },
    { type: "SUSCRIPTOR QUE EFECTUA EL PAGO PERO ESTE NO ES APLICADO POR LA EMPRESA EN LA FACTURACION" },
    { type: "INCONFORMIDAD POR LA NORMALIZACION DEL SERVICIO" },
    { type: "NEGACION DE LA SOLICITUD DE SUSPENSION" },
  ];

  // Reclamo — defaultBloquea: true → "BLOQUEA FACTURACION" por defecto, false → "NO BLOQUEA FACTURACION"
  readonly typesSubMenu2Dano = [
    { type: "SISTEMA FUNCIONAL",                  defaultBloquea: false },
    { type: "REPOSICION",                         defaultBloquea: true  },
    { type: "SISFV NO ENCONTRADA",                defaultBloquea: false },
    { type: "SISFV ABANDONADO",                   defaultBloquea: true  },
    { type: "RESTRICCIONES ACCESO",               defaultBloquea: false },
    { type: "AUSENTE",                            defaultBloquea: false },
    { type: "AUSENCIA DE EQUIPOS",                defaultBloquea: false },
    { type: "EQUIPOS MODIFICADOS(HOMOLOGACION)",  defaultBloquea: false },
  ];

  // Otros
  readonly typesSubMenu2GestionCartera = [
    { type: "ACUERDO DE PAGO" },
    { type: "PAGO MENSUAL" },
    { type: "SIN PROMESA" },
    { type: "EQUIVOCADO" },
    { type: "BUZON DE MENSAJES" },
    { type: "MENSAJE DE TEXTO" },
    { type: "NO CONTESTA" },
    { type: "MENSAJE CON TERCERO" },
  ];

  readonly typesSubMenu2LlamadaInformacion = [
    { type: "REPORTE GENERAL" },
    { type: "NO CONTESTA" },
    { type: "EQUIVOCADO" },
    { type: "BUZON DE MENSAJES" },
    { type: "MENSAJE CON TERCERO" },
  ];

  readonly typesSubMenu2GestionSocial = [
    { type: "HURTO PARCIAL",          defaultBloquea: true  },
    { type: "HURTO COMPLETO",         defaultBloquea: true  },
    { type: "TRASLADO NO AUTORIZADO", defaultBloquea: false },
    { type: "SOLUCION ABANDONADA",    defaultBloquea: false },
    { type: "RESTRICCIONES DE ACCESO",defaultBloquea: false },
    { type: "SISFV FUNCIONAL",        defaultBloquea: false },
    { type: "SISFV NO FUNCIONAL",        defaultBloquea: false },
  ];

  // Resultado Operativo — defaultBloquea: true → "BLOQUEA FACTURACION", false → "NO BLOQUEA FACTURACION"
  readonly typesSubMenu2ResultadoOperativo = [
    { type: "REPOSICION",               defaultBloquea: true  },
    { type: "SISFV NO ENCONTRADA",      defaultBloquea: false },
    { type: "RESTRICCIONES ACCESO",     defaultBloquea: false },
    { type: "AUSENTE",                  defaultBloquea: false },
    { type: "AUSENCIA DE EQUIPOS",      defaultBloquea: false },
    { type: "SUSPENSION DEL SERVICIO",  defaultBloquea: false },
    { type: "RECONEXION DEL SERVICIO",  defaultBloquea: false },
  ];

  // ─── Submenú nivel 3 ───────────────────────────────────────────────────────
  readonly typesSubMenu3Facturacion = [
    { type: "BLOQUEA FACTURACION" },
    { type: "NO BLOQUEA FACTURACION" },
    { type: "DESCUENTO COMERCIAL" },
  ];

  // ─── Visibilidad de submenús ───────────────────────────────────────────────
  // Nivel 1
  opcionPeticion: boolean = false;
  opcionQueja: boolean = false;
  opcionReclamo: boolean = false;
  opcionOtros: boolean = false;

  // Nivel 2
  opcionSub2ConsultaInfo: boolean = false;
  opcionSub2SolicitudFactura: boolean = false;
  opcionSub2AtencionDeficiente: boolean = false;
  opcionSub2InconformidadFacturacion: boolean = false;
  opcionSub2Dano: boolean = false;
  opcionSub2GestionCartera: boolean = false;
  opcionSub2LlamadaInformacion: boolean = false;
  opcionSub2GestionSocial: boolean = false;
  opcionSub2ResultadoOperativo: boolean = false;

  // Nivel 3
  opcionSub3Facturacion: boolean = false;

  // ─── Helpers ───────────────────────────────────────────────────────────────
  /** Usuarios que pueden ingresar fecha manual en el cambio de estado */
  readonly usuariosConFechaManual = ["747", "749", "755", "756", "750", "641"];

  get permiteFechaManual(): boolean {
    return (
      this.global.idRole === 1 ||
      this.usuariosConFechaManual.includes(this.IDUSUARIO)
    );
  }

  get permiteResultadoOperativo(): boolean {
    return this.usuariosConFechaManual.includes(this.IDUSUARIO);
  }

  get typesSubMenu1OtrosVisible() {
    return this.typesSubMenu1Otros.filter(
      item => item.type !== "RESULTADO OPERATIVO" || this.permiteResultadoOperativo
    );
  }

  constructor(
    private subir: SubirArchivosService,
    private excelService: ExcelService,
    public global: GlobalService,
    public ruta: Router,
    private spinner: NgxSpinnerService,
    public alerta: GlobalAlertService,
    public modalService: NgbModal
  ) {
    this.global.initData();
  }

  // ─── Lifecycle ─────────────────────────────────────────────────────────────
  ngOnInit(): void {
    const idGuardado = localStorage.getItem("Id_Ticket");
    this.global.Id_Ticket = idGuardado;

    if (this.global.Id_Ticket == undefined) {
      this.ruta.navigateByUrl("/user-ticket");
      return;
    }

    this.spinner.show();
    this.IDUSUARIO = this.global.Id_Usuario;
    this.fechaSeleccionada = moment().format("YYYY-MM-DDTHH:mm");
    this.informacionBeneficiario =
      this.global.informacion ??
      JSON.parse(window.localStorage.getItem("informacion"));

    const pdatainfo = {
      option: "insertar2",
      texto: `SELECT A.*,
        (SELECT C.Nombre FROM db_liwa.Seccionales C WHERE C.Id_seccional = A.Id_Seccional) AS Nombre_seccional,
        (SELECT E.Nombre FROM db_liwa.tipoProyecto E WHERE E.id_tipoProyecto = A.Id_Proyecto) AS Nombre_proyecto,
        A.Id_Proyecto FROM db_liwa.AOM A WHERE A.IsDelete=0 AND A.Id = '${this.informacionBeneficiario[0][0]}';`,
    };
    this.global.consultar(pdatainfo, async (err, response) => {
      this.informacionBeneficiario = await response;
    });

    const commentarios = { option: "tickets_comentarios", idticket: this.global.Id_Ticket };
    this.global.consultar(commentarios, async (err, response) => {
      this.comentarios = await response;
    });

    const tipifica = {
      option: "insertar2",
      texto: `SELECT * FROM db_liwa.Tickets_New WHERE IsDelete=0 AND Id_Tickets = '${this.global.Id_Ticket}';`,
    };
    this.global.consultar(tipifica, async (err, responset) => {
      if (responset.length > 0) {
        this.DataTipifica = responset;
        this.valorCanal = this.DataTipifica[0][19];
        this.valorMenu1 = this.DataTipifica[0][6];
        this.handleChangeSubMenu1();
        this.valorSubMenu1 = this.DataTipifica[0][7];
        this.handleChangeSubMenu2();
        this.valorSubMenu2 = this.DataTipifica[0][8];
        this.handleChangeSubMenu3();
        this.valorSubMenu3 = this.DataTipifica[0][9] || "-";
        this.handleChangeDescriction();
        this.descriptionBenefit = this.DataTipifica[0][10];

        const creado = {
          option: "insertar2",
          texto: `SELECT UserName FROM db_liwa.User WHERE Id_User = '${this.DataTipifica[0][1]}';`,
        };
        this.global.consultar(creado, async (err, responset2) => {
          if (responset2.length > 0) {
            this.DataTipifica2 = responset2;
            this.creadopor = this.DataTipifica2[0][0];
          }
        });
      }
    });

    const consultaBeneficiario = {
      option: "insertar2",
      texto: `SELECT *,(db_liwa.getdays(Creation_Date, NOW())) FROM db_liwa.Tickets_New WHERE IsDelete=0 AND Id_Beneficiario = '${this.informacionBeneficiario[0][0]}';`,
    };
    this.global.consultar(consultaBeneficiario, async (err, response1) => {
      this.ticketsBeneficiario = await response1;
      this.consultandoMantenimientos();
      if (this.ticketsBeneficiario.length > 0) {
        $(function () {
          $("#userTicket").DataTable({
            responsive: false,
            destroy: true,
            retrieve: true,
            paging: true,
            info: false,
            pagingType: "numbers",
            language: { url: "//cdn.datatables.net/plug-ins/1.10.15/i18n/Spanish.json" },
          });
        });
      } else {
        this.islistmaintenance();
      }
      this.banderaTickets = true;
      this.spinner.hide();
    });

    this.clientClass = this.global.CLIENTDATALIWA;

    const pdata1 = { option: "Update_ticket", ticket: this.global.Id_Ticket };
    $.ajax({
      data: pdata1, cache: false, dataType: "json", type: "post",
      url: "https://www.php.engenius.com.co/DatabaseLIWA.php",
    }).then((response) => {
      this.Historial = response;
      this.banderaActualizar = true;

      const pdata2 = { option: "files", ticket: this.global.Id_Ticket };
      $.ajax({
        data: pdata2, cache: false, dataType: "json", type: "post",
        url: "https://www.php.engenius.com.co/DatabaseLIWA.php",
      }).then((response2) => {
        this.Archivos = response2;
        this.flagS = true;
        this.spinner.hide();
      }).catch(() => {});
    }).catch(() => {});

    const pdata3 = { option: "estados" };
    $.ajax({
      data: pdata3, cache: false, dataType: "json", type: "post",
      url: "https://www.php.engenius.com.co/DatabaseLIWA.php",
    }).then((response3) => {
      this.Estados = response3;
    }).catch(() => {});
  }

  // ─── Manejadores de submenús ───────────────────────────────────────────────
  private resetSubMenus1(): void {
    this.opcionPeticion = false;
    this.opcionQueja = false;
    this.opcionReclamo = false;
    this.opcionOtros = false;
  }

  private resetSubMenus2(): void {
    this.opcionSub2ConsultaInfo = false;
    this.opcionSub2SolicitudFactura = false;
    this.opcionSub2AtencionDeficiente = false;
    this.opcionSub2InconformidadFacturacion = false;
    this.opcionSub2Dano = false;
    this.opcionSub2GestionCartera = false;
    this.opcionSub2LlamadaInformacion = false;
    this.opcionSub2GestionSocial = false;
    this.opcionSub2ResultadoOperativo = false;
  }

  private resetSubMenus3(): void {
    this.opcionSub3Facturacion = false;
  }

  handleChangeSubMenu1(): void {
    this.resetSubMenus1();
    this.resetSubMenus2();
    this.resetSubMenus3();
    this.valorSubMenu1 = "-";
    this.valorSubMenu2 = "-";
    this.valorSubMenu3 = "-";
    this.banderaCrearTicket = false;

    switch (this.valorMenu1) {
      case "PETICION": this.opcionPeticion = true; break;
      case "QUEJA":    this.opcionQueja = true;    break;
      case "RECLAMO":  this.opcionReclamo = true;  break;
      case "OTROS":    this.opcionOtros = true;    break;
    }
  }

  handleChangeSubMenu2(): void {
    this.resetSubMenus2();
    this.resetSubMenus3();
    this.valorSubMenu2 = "-";
    this.valorSubMenu3 = "-";
    this.banderaCrearTicket = false;

    switch (this.valorSubMenu1) {
      // ── Peticion ──
      case "CONSULTA DE INFORMACION":
        this.opcionSub2ConsultaInfo = true;
        break;
      case "SOLICITUD DE FACTURA Y/O COMPROBANTE":
        this.opcionSub2SolicitudFactura = true;
        break;
      case "CAMBIO DE TITULARIDAD":
      case "SOLICITUD DE TRASLADO":
      case "AUSENCIA DE EQUIPOS":
      case "SOLICITUD DE DESESTIMIENTO":
        this.valorSubMenu3 = "NO BLOQUEA FACTURACION";
        this.banderaCrearTicket = true;
        break;
      // ── Queja ──
      case "ATENCION DEFICIENTE":
        this.opcionSub2AtencionDeficiente = true;
        break;
      case "INCONFORMIDAD CON FACTURACION":
        this.opcionSub2InconformidadFacturacion = true;
        break;
      // ── Reclamo ──
      case "DAÑO":
        this.opcionSub2Dano = true;
        break;
      // ── Otros ──
      case "GESTION DE CARTERA":
        this.opcionSub2GestionCartera = true;
        break;
      case "LLAMADA DE INFORMACION":
        this.opcionSub2LlamadaInformacion = true;
        break;
      case "GESTION SOCIAL":
        this.opcionSub2GestionSocial = true;
        break;
      case "RESULTADO OPERATIVO":
        this.opcionSub2ResultadoOperativo = true;
        break;
    }
  }

  handleChangeSubMenu3(): void {
    this.resetSubMenus3();
    this.valorSubMenu3 = "-";
    this.banderaCrearTicket = false;
    this.mensajeAdvertenciaSubMenu3 = "";

    const esDano              = this.valorMenu1 === "RECLAMO" && this.valorSubMenu1 === "DAÑO";
    const esTraslado          = this.valorMenu1 === "OTROS"   && this.valorSubMenu1 === "GESTION SOCIAL";
    const esResultadoOperativo = this.valorMenu1 === "OTROS"  && this.valorSubMenu1 === "RESULTADO OPERATIVO";

    if ((esDano || esTraslado || esResultadoOperativo) && this.valorSubMenu2 && this.valorSubMenu2 !== "-") {
      this.opcionSub3Facturacion = true;

      if (esDano) {
        const opcion = this.typesSubMenu2Dano.find(d => d.type === this.valorSubMenu2);
        this.valorSubMenu3 = opcion?.defaultBloquea
          ? "BLOQUEA FACTURACION"
          : "NO BLOQUEA FACTURACION";
        this.banderaCrearTicket = true;
      } else if (esTraslado) {
        const opcion = this.typesSubMenu2GestionSocial.find(d => d.type === this.valorSubMenu2);
        this.valorSubMenu3 = opcion?.defaultBloquea
          ? "BLOQUEA FACTURACION"
          : "NO BLOQUEA FACTURACION";
        this.banderaCrearTicket = true;
      } else if (esResultadoOperativo) {
        const opcion = this.typesSubMenu2ResultadoOperativo.find(d => d.type === this.valorSubMenu2);
        this.valorSubMenu3 = opcion?.defaultBloquea
          ? "BLOQUEA FACTURACION"
          : "NO BLOQUEA FACTURACION";
        this.banderaCrearTicket = true;
      }
    } else if (this.valorSubMenu2 && this.valorSubMenu2 !== "-") {
      this.valorSubMenu3 = "NO BLOQUEA FACTURACION";
      this.banderaCrearTicket = true;
    }
  }

  handleChangeDescriction(): void {
    if (this.valorSubMenu3 && this.valorSubMenu3 !== "-") {
      this.banderaCrearTicket = true;
    } else if (this.valorSubMenu2 && this.valorSubMenu2 !== "-") {
      this.banderaCrearTicket = true;
    }
    this.mensajeAdvertenciaSubMenu3 = this.calcularAdvertenciaSubMenu3();
  }

  onChangeSubMenu3Actualizar(): void {
    this.mensajeAdvertenciaSubMenu3 = this.calcularAdvertenciaSubMenu3();
  }

  private calcularAdvertenciaSubMenu3(): string {
    if (!this.valorSubMenu2 || this.valorSubMenu2 === "-") return "";
    if (!this.valorSubMenu3 || this.valorSubMenu3 === "-") return "";

    let item: { type: string; defaultBloquea?: boolean } | undefined;

    const esDano = this.valorMenu1 === "RECLAMO" && this.valorSubMenu1 === "DAÑO";
    const esGestionSocial = this.valorMenu1 === "OTROS" && this.valorSubMenu1 === "GESTION SOCIAL";
    const esResultadoOp = this.valorMenu1 === "OTROS" && this.valorSubMenu1 === "RESULTADO OPERATIVO";

    if (esDano)           item = this.typesSubMenu2Dano.find(d => d.type === this.valorSubMenu2);
    else if (esGestionSocial) item = this.typesSubMenu2GestionSocial.find(d => d.type === this.valorSubMenu2);
    else if (esResultadoOp)   item = this.typesSubMenu2ResultadoOperativo.find(d => d.type === this.valorSubMenu2);

    if (!item || item.defaultBloquea === undefined) return "";

    const defaultTexto = item.defaultBloquea ? "BLOQUEA FACTURACION" : "NO BLOQUEA FACTURACION";
    if (this.valorSubMenu3 !== defaultTexto) {
      return `Recuerda que "${this.valorSubMenu2}" por defecto ${defaultTexto}.`;
    }
    return "";
  }

  // ─── Actualizar ticket ─────────────────────────────────────────────────────
  Actualizar(): void {
    if (!this.description || !this.estado || this.estado == "0") {
      return this.alerta.descErr();
    }

    const fecha = this.permiteFechaManual && this.fechaSeleccionada
      ? moment(this.fechaSeleccionada).format("YYYY-MM-DD HH:mm:ss")
      : moment().format("YYYY-MM-DD HH:mm:ss");

    const query2 = `
      REPLACE INTO db_liwa.Update_Tickets
      (Id_Ticket, Description, Date, Id_Statuses, IsDelete, IsActive, Id_user)
      VALUES (
        '${this.global.Id_Ticket}',
        '${this.description}',
        '${fecha}',
        '${this.estado}',
        0, 1,
        '${this.global.Id_Usuario}'
      );`;

    this.global.consultar({ option: "insertar3", texto: query2 }, async (err, response) => {
      if (err || !response) return this.alerta.descErr("Error al actualizar el ticket");

      const sub3Clause = this.opcionSub3Facturacion && this.valorSubMenu3 && this.valorSubMenu3 !== '-'
        ? `, SubMenu3 = '${this.valorSubMenu3}'`
        : '';
      const query5 = `UPDATE db_liwa.Tickets_New SET Id_Statuses='${this.estado}'${sub3Clause} WHERE Id_Tickets='${this.global.Id_Ticket}';`;
      this.global.consultar({ option: "insertar3", texto: query5 }, async (err5, response5) => {
        if (err5 || !response5) return this.alerta.descErr("Error al actualizar el ticket");

        this.eviarSMS(this.estado, this.global.Id_Ticket);
        // Si el ticket pasa a estado cerrado, cerrar escalamientos relacionados automáticamente
        const CERRADOS = [6, 7, 10, 11, 15, 16, 17, 18];
        if (CERRADOS.includes(Number(this.estado))) {
          this.global.consultar(
            { option: 'cerrar-escalamientos-ticket', idticket: this.global.Id_Ticket },
            () => {}
          );
        }
        this.enviarcorreo();

        setTimeout(() => {
          this.alerta.descValid("El ticket se actualizó con éxito");
          this.description = undefined;
          this.estado = 0;
          this.fechaSeleccionada = null;
          this.editandoSubMenu3 = false;
          this.mensajeAdvertenciaSubMenu3 = "";
          this.ngOnInit();
        }, 1000);

        this.handleClick(1);
      });
    });
  }

  // ─── Normalizar tipificación: MAYÚSCULAS · sin tildes (excepto Ñ) · sin dobles espacios ─
  private normalizarTipificacion(s: string): string {
    if (!s) return s;
    // Preservar ñ/Ñ antes de eliminar diacríticos
    return s
      .replace(/ñ/g, '__NIO__').replace(/Ñ/g, '__NIO__')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/__NIO__/g, 'Ñ')
      .toUpperCase()
      .replace(/\s{2,}/g, ' ')
      .trim();
  }

  // ─── Modificar tipificación ────────────────────────────────────────────────
  get permiteFechaTipificacion(): boolean {
    return this.usuariosConFechaManual.includes(this.IDUSUARIO);
  }

  modificar(): void {
    this.spinner.show();

    const fechaModificacion = this.permiteFechaTipificacion && this.fechaTipificacion
      ? moment(this.fechaTipificacion).format("YYYY-MM-DD HH:mm:ss")
      : moment().format("YYYY-MM-DD HH:mm:ss");

    // Trazabilidad: capturamos los valores anteriores antes de modificar
    const tipificacionAnterior = `${this.DataTipifica?.[0]?.[6] || "-"} > ${this.DataTipifica?.[0]?.[7] || "-"} > ${this.DataTipifica?.[0]?.[8] || "-"}> ${this.DataTipifica?.[0]?.[9] || "-"}`;
    const tipificacionNueva    = `${this.valorMenu1 || "-"} > ${this.valorSubMenu1 || "-"} > ${this.valorSubMenu2 || "-"}> ${this.valorSubMenu3 || "-"}`;
    const descripcionTrazabilidad = `Cambio de tipificación generada por asesor. Anterior: [${tipificacionAnterior}] → Nueva: [${tipificacionNueva}]`;

    const nMenu = this.normalizarTipificacion(this.valorMenu1);
    const nSub1 = this.normalizarTipificacion(this.valorSubMenu1);
    const nSub2 = this.normalizarTipificacion(this.valorSubMenu2 || '-');
    const nSub3Raw = (this.valorSubMenu3 && this.valorSubMenu3 !== '-') ? this.valorSubMenu3 : 'NO BLOQUEA FACTURACION';
    const nSub3 = this.normalizarTipificacion(nSub3Raw);

    const esEqMod = nSub2 === "EQUIPOS MODIFICADOS(HOMOLOGACION)";
    // Para EqMod: Creation_Date = fecha del cambio (reinicia semáforo)
    // CreationDateEQMOD = fecha más antigua en Update_Tickets (fecha real original)
    const eqmodClause = esEqMod
      ? `, Creation_Date = "${fechaModificacion}", CreationDateEQMOD = COALESCE(CreationDateEQMOD, (SELECT MIN(ut.Date) FROM db_liwa.Update_Tickets ut WHERE ut.Id_Ticket = "${this.global.Id_Ticket}" AND ut.IsDelete = 0))`
      : "";
    const modifica = {
      option: "insertar3",
      texto: `UPDATE db_liwa.Tickets_New SET Id_Statuses = "2", Menu = "${nMenu}", SubMenu1 = "${nSub1}", SubMenu2 = "${nSub2}", SubMenu3 = "${nSub3}", Description = "${this.descriptionBenefit}"${eqmodClause} WHERE Id_Tickets = "${this.global.Id_Ticket}";`,
    };
    this.global.consultar(modifica, async (errm, responsem) => {
      if (errm == null && responsem == true) {
        const Update = {
          option: "insertar3",
          texto: `INSERT INTO db_liwa.Update_Tickets (Id_Ticket,Description,Id_Statuses,Date,IsDelete,IsActive,Id_user) VALUES ("${this.global.Id_Ticket}","${descripcionTrazabilidad}","2","${fechaModificacion}",0,1,"${this.global.Id_Usuario}")`,
        };
        this.global.consultar(Update, async (errU, responseU) => {
          if (errU == null && responseU == true) {
            this.alerta.descValid(`Se modifico con exito la tipificacion del ticket: ${this.global.Id_Ticket}.`);
          } else {
            this.alerta.descErr("Se encontro algun error, intenta de nuevo.");
          }
          // Actualizar responsable y estado del escalamiento asociado si existe
          this.global.consultar({
            option: 'actualizar-escalamiento-tipificacion',
            idticket: this.global.Id_Ticket,
            tipificacion: nMenu,
            subMenu1: nSub1,
            subMenu2: nSub2,
          }, () => {});
          this.spinner.hide();
          this.ngOnInit();
          this.handleClick(1);
        });
      } else {
        this.alerta.descErr("Se encontro algun error, intenta de nuevo.");
        this.spinner.hide();
        this.ngOnInit();
      }
    });
  }

  // ─── Correo y SMS ──────────────────────────────────────────────────────────
  enviarcorreo(): void {
    const pdata = { option: "estado", texto: this.estado };
    this.global.consultar(pdata, async (err, response) => {
      this.NameP = response[0];
      this.NameP = JSON.stringify(this.NameP[0]).replace(/"/g, "");
    });
    setTimeout(() => {
      const pdata9 = {
        option: "mailA",
        ticket: this.global.Id_Ticket,
        texto: this.NameP,
        user: this.global.USERDATALIWA[8],
        novedad: this.descriptionModal,
      };
      this.global.consultar(pdata9, async (err2, response2) => {});
    }, 500);
  }

  eviarSMS(idTk: string, statusTk: string): void {
    setTimeout(() => {
      const pdata1 = {
        option: "insertar2",
        texto: `SELECT T.Id_Proyecto, T.Id_Seccional, T.Id_Beneficiario,
          (SELECT M.Id_Maintenance FROM db_liwa.Maintenance_new M WHERE M.Id_Ticket = T.Id_Tickets),
          (SELECT M.Id_Technical FROM db_liwa.Maintenance_new M WHERE M.Id_Ticket = T.Id_Tickets),
          (SELECT M.Status FROM db_liwa.Maintenance_new M WHERE M.Id_Ticket = T.Id_Tickets),
          (SELECT S.Name_Status FROM db_liwa.Ticket_Statuses S WHERE S.Id_Statuses = T.Id_Statuses),
          (SELECT B.Telefono FROM db_liwa.AOM B WHERE B.Id = T.Id_Beneficiario)
          FROM db_liwa.Tickets_New T WHERE T.Id_Tickets = '${idTk}';`,
      };
      this.global.consultar(pdata1, async (err9, response9) => {
        const message = `DISPOWER le informa que cambio de estado PQR No ${idTk} , a ${statusTk} cualquier inquietud comunicarce a la linea 0180000413824`;
        const pdata9 = { number: "57" + response9[0][0], message, type: "1" };
        const pdata7 = { number: "57" + "3008775560", message, type: "1" };
        const pdata6 = { number: "57" + "3006826116", message, type: "1" };

        const query = `REPLACE INTO db_liwa.MensajesAOM (Id_Proyecto,Id_Seccional,Id_Beneficiario,Id_Maintenance,Id_Ticket,Id_User,Id_Tecnico,Numero_Dest,Tipo_Mantenimiento,Tipo_Ticket,ContenidoSMS)
          VALUES ('${response9[0][0]}','${response9[0][1]}','${response9[0][2]}','${response9[0][3]}','${idTk}','${this.global.Id_Usuario}','${response9[0][4]}','${pdata9.number}','${response9[0][5]}','${statusTk}','${message}');`;

        this.global.consultarSMS(pdata9, () => {
          this.global.consultarSMS(pdata7, () => {
            this.global.consultarSMS(pdata6, () => {
              this.global.consultar({ option: "insertar3", texto: query }, async () => {});
            });
          });
        });
      });
    }, 500);
  }

  // ─── Excel ─────────────────────────────────────────────────────────────────
  exportAsXLSX(): void {
    this.spinner.show();
    this.Toexcel = [["idTicket:", "Creador por", "Comentario"]];

    if (this.comentarios.length === 0) {
      this.Toexcel.push(["NO DATA", "NO DATA", "NO DATA"]);
    } else {
      for (const c of this.comentarios) {
        this.Toexcel.push([c[3], c[4], c[1]]);
      }
    }

    setTimeout(() => {
      this.excelService.exportAsExcelFile2(this.Toexcel, "datos", "comentarios_" + this.global.Id_Ticket);
      setTimeout(() => {
        this.spinner.hide();
        this.Toexcel = [["idTicket:", "Creador por", "Comentario"]];
      }, 1000);
    }, 1500);
  }

  // ─── Archivos ──────────────────────────────────────────────────────────────
  onFileSelected(event: any): void {
    const selectedFiles = event.target.files;
    for (let i = 0; i < selectedFiles.length; i++) {
      const reader = new FileReader();
      reader.onload = (e: any) => {
        const imagen = new Image();
        imagen.src = e.target.result;
        this.srcImg[i] = imagen.src;
      };
      reader.readAsDataURL(selectedFiles[i]);
    }
    this.Evidence = true;
  }

  dataURItoBlob(dataURI: string): Blob {
    const byteString = window.atob(dataURI);
    const arrayBuffer = new ArrayBuffer(byteString.length);
    const int8Array = new Uint8Array(arrayBuffer);
    for (let i = 0; i < byteString.length; i++) {
      int8Array[i] = byteString.charCodeAt(i);
    }
    return new Blob([int8Array], { type: "image/jpeg" });
  }

  loadPhoto(dataentry: any): void {
    if (!this.descriptionModal) {
      this.alerta.descErr();
      return;
    }
    this.spinner.show();
    this.NickName = this.global.Id_Ticket;

    if (!this.srcImg) {
      this.alerta.descErr("Error al subir la foto, verifique nuevamente");
      return;
    }

    let con1 = 0;
    let con2 = 0;
    for (let i = 0; i < this.srcImg.length; i++) {
      con1++;
      const FOTOO = this.srcImg[i].slice(23);
      const imageName = i + "-" + moment().unix() + ".jpg";
      const imageBlob = this.dataURItoBlob(FOTOO);
      const data = new FormData();
      data.append("image", FOTOO);
      data.append("nombre", imageName);
      data.append("ruta", this.NickName);

      $.ajax({
        url: "https://fotos.engenius.com.co/subir_archivo_TicketLW.php",
        type: "post", dataType: "json", data, processData: false, contentType: false,
      }).then((data1) => {
        this.imgsUrls[i] = data1;
        con2++;
        if (!data1 || data1 === "BADEXT" || data1 === "NULL") {
          this.alerta.descErr("Error al subir la foto, verifique nuevamente");
          return;
        }
        const query =
          `REPLACE INTO db_liwa.Ticket_Files (Id_Ticket,Name_File,Type_File,File,IsDelete,IsActive)` +
          ` VALUES ('${this.NickName}','${imageName}','jpg','${data1}','0','1');`;
        this.global.consultar({ option: "insertar3", texto: query }, async (err, response) => {
          if (err == null && response == true) {
            this.alerta.descValid("El ticket se creo con éxito");
          } else {
            this.alerta.descErr("Error al crear el ticket, verifique que no hayan campos vacíos");
          }
        });
      });
    }
  }

  referenciaArchivo(ev: any): void {
    this.File = ev.target;
  }

  actualizarPhoto(): void {
    if (!this.descriptionModal || !this.File) {
      this.alerta.descErr("Es necesario colocar una descripcion o el archivo.");
      return;
    }
    this.spinner.show();
    const img: any = this.File;
    const form = new FormData();
    form.append("opcion", "documents");
    form.append("file", img.files[0]);
    form.append("idTicket", this.global.Id_Ticket);

    this.subir.subirarchivo(form).subscribe(
      (resp) => {
        if (resp.status) {
          const Update = {
            option: "insertar3",
            texto: `UPDATE db_liwa.Update_Tickets SET Description = "${this.descriptionModal}", url = ${resp.url} WHERE Id_Update = "${this.global.idEdit}"`,
          };
          this.global.consultar(Update, async (errU, responseU) => {
            if (errU == null && responseU == true) {
              this.alerta.descValid("Se cargo con exito el archivo.");
            } else {
              this.alerta.descErr("Se encontro algun error, intenta de nuevo.");
            }
            this.spinner.hide();
            this.ngOnInit();
            this.file = undefined;
          });
        } else {
          this.alerta.descErr("Algo anda mal! vuelva a intentar cargar el archivo y valide el formato");
          this.spinner.hide();
          this.file = undefined;
        }
      },
      () => {
        this.alerta.descErr("Revisa bien el formato que seleccionaste porfavor");
        this.spinner.hide();
        this.file = undefined;
      }
    );
  }

  // ─── Modales ───────────────────────────────────────────────────────────────
  abrirAdjuntoTimeline(url: string): void {
    const clean = String(url).replace(/^['"]|['"]$/g, '').trim();
    if (!clean || clean === 'null' || !clean.startsWith('http')) return;
    window.open(encodeURI(clean), '_blank');
  }

  openFormtoUpdate(content: any, data: any, comentario: any): void {
    this.global.idEdit = data;
    this.descriptionModal = comentario;
    this.modalService.open(content, { ariaLabelledBy: "modal-updateVisit" }).result.then(
      () => {}, () => {}
    );
  }

  openEditQuestion(content: string, id_ticket: string, option: number | string): void {
    this.spinner.show();
    if (Number(option) === 1) {
      const pdata1 = { option: "Update_ticket", ticket: id_ticket };
      $.ajax({
        data: pdata1, cache: false, dataType: "json", type: "post",
        url: "https://www.php.engenius.com.co/DatabaseLIWA.php",
      }).then((response) => {
        this.HistorialModal = response;
        this.banderaActualizar = true;

        const pdata2 = { option: "files", ticket: id_ticket };
        $.ajax({
          data: pdata2, cache: false, dataType: "json", type: "post",
          url: "https://www.php.engenius.com.co/DatabaseLIWA.php",
        }).then((response2) => {
          this.Archivos = response2;
          this.spinner.hide();
          this.modalService.open(content, { ariaLabelledBy: "modal-editQuestion" }).result.then(
            () => {},
            () => {
              this.HistorialModal = [];
              this.banderaComentaruioTecnico = false;
            }
          );
        }).catch(() => { this.spinner.hide(); });
      }).catch(() => { this.spinner.hide(); });
    } else if (Number(option) === 2) {
      const pdata11 = { option: "Update_mantenimiento", mantenimiento: id_ticket };
      this.global.consultar(pdata11, async (err, response) => {
        this.HistorialModal = await response;
        const pdate = {
          option: "insertar2",
          texto: `SELECT * FROM db_liwa.Tecnico WHERE instalMant = '${this.HistorialModal[0][1]}';`,
        };
        this.global.consultar(pdate, (err, respuesta) => {
          if (respuesta.length > 0) {
            this.banderaComentaruioTecnico = true;
            this.comentariaTecnico = respuesta[0][45];
          }
          this.spinner.hide();
          this.modalService.open(content, { ariaLabelledBy: "modal-editQuestion" }).result.then(
            () => {},
            () => {
              this.HistorialModal = [];
              this.banderaComentaruioTecnico = false;
            }
          );
        });
      });
    }
  }

  openDescripcion(content: any, itemValue: any): void {
    this.comentario = itemValue;
    this.modalService.open(content, { ariaLabelledBy: "modal-descripcion" });
  }

  // ─── Navegación y utilidades ───────────────────────────────────────────────
  handleClick(data: number): void {
    this.windowA = data !== 1 ? true : !this.windowA;
    this.windowB = data !== 2 ? true : !this.windowB;
    this.windowC = data !== 3 ? true : !this.windowC;
    this.windowD = data !== 4 ? true : !this.windowD;
  }

  consultandoMantenimientos(): void {
    const pdataM = {
      option: "insertar2",
      texto: `SELECT M.*, U.UserName,
        (SELECT S.UserName FROM db_liwa.User S WHERE S.Id_User = M.Id_Technical) AS NombreTecnico,
        (db_liwa.getdays(M.LastInsert, NOW())) AS Semaforo FROM db_liwa.Maintenance_new M
        INNER JOIN db_liwa.User U ON M.Id_Beneficiario = U.Id_User WHERE M.IsDelete=0 AND M.Id_Beneficiario="${this.informacionBeneficiario[0][0]}";`,
    };
    this.global.consultar(pdataM, async (err9, response9) => {
      this.Mantenimiento = await response9;
    });
  }

  islistmaintenance(): void {
    if (!this.listActived) {
      this.listForschedule = !this.listForschedule;
    } else {
      this.listActived = false;
      this.listForschedule = !this.listForschedule;
    }
    $(function () {
      $("#TableVisitasMantenimientos").DataTable({
        responsive: false, destroy: true, retrieve: true, paging: true, info: false,
        pagingType: "numbers",
        language: { url: "//cdn.datatables.net/plug-ins/1.10.15/i18n/Spanish.json" },
      });
    });
  }

  islisttickets(): void {
    if (!this.listForschedule) {
      this.listActived = !this.listActived;
    } else {
      this.listForschedule = false;
      this.listActived = !this.listActived;
    }
    $(function () {
      $("#userTicket").DataTable({
        responsive: false, destroy: true, retrieve: true, paging: true, info: false,
        pagingType: "numbers",
        language: { url: "//cdn.datatables.net/plug-ins/1.10.15/i18n/Spanish.json" },
      });
    });
  }

  stateBadge(data: any, estado: any, posicion: any): string {
    const cerrados = [6, 7, 10, 11, 12, 15, 16, 17, 18];
    const dias = Number(data);
    if (!cerrados.includes(Number(estado))) {
      if (!isNaN(dias) && dias >= 0 && dias <= 6) {
        this.ticketsBeneficiario[posicion][13] = "Leve";
        return "badge badge-leve";
      } else if (!isNaN(dias) && dias >= 7 && dias <= 14) {
        this.ticketsBeneficiario[posicion][13] = "Moderado";
        return "badge badge-warning";
      } else {
        this.ticketsBeneficiario[posicion][13] = "Critico";
        return "badge badge-danger";
      }
    } else {
      this.ticketsBeneficiario[posicion][13] = "Cerrado";
      return "badge badge-success";
    }
  }

  stateBadge2(data: any): string {
    if (data === "Agendado") return "badge badge-warning";
    if (data === "Terminado") return "badge badge-success";
    if (data === "Ejecución") return "badge badge-leve";
    return "badge badge-warning";
  }

  formatt(item: any): string {
    return moment(item).format("YYYY/MM/DD HH:mm");
  }

  verdetalle(id: any): void {
    const pdata12 = {
      option: "insertar2",
      texto: `SELECT M.*, U.UserName,
        (SELECT S.UserName FROM db_liwa.User S WHERE S.Id_User = M.Id_Technical),
        (db_liwa.getdays(M.LastInsert, NOW())) AS Semaforo,
        (SELECT Vereda FROM db_liwa.AOM WHERE id = M.Id_Beneficiario) as vereda,
        (SELECT Nombre_Completo FROM db_liwa.AOM WHERE id = M.Id_Beneficiario) as NombreBeneficiario
        FROM db_liwa.Maintenance_new M INNER JOIN db_liwa.User U ON M.Id_Beneficiario = U.Id_User
        WHERE (SELECT C.Id_Client FROM db_liwa.tipoProyecto C WHERE C.Id_Client = ${this.global.Id_Client} AND C.id_tipoProyecto = M.idProyecto)
        AND M.IsDelete=0 AND M.Id_Maintenance = "${id}";`,
    };
    this.global.consultar(pdata12, async (err9, response9) => {
      if (response9) {
        this.global.Id_Mantenimiento = response9[0];
        this.ruta.navigateByUrl("/ver-visita");
      } else {
        this.alerta.descErr("Lastimosamente el registro aun no se encuentra!");
      }
    });
  }
}